import { useState, useRef } from 'react';
import { getIsMobileWidth2 } from '@elem/utils/devices';

function useHoverOpen(delay = 100) {
    const [open, setOpen] = useState(false);
    const [hasContinue, setHasContinue] = useState<boolean>(false);
    const timer = useRef<number | null>(null);

    const show = () => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
        setOpen(true);
    };

    const immediatelyHide = () => {
        setOpen(false);
    };

    const hide = () => {
        timer.current = window.setTimeout(() => {
            setOpen(false);
        }, delay);
    };

    return { open, show, hide, immediatelyHide, hasContinue, setHasContinue };
}

export default useHoverOpen;
